<template>
  <div :class="['koma-board-grid',isEnemyBoard? 'enemyBoard':'selfBoard']">
    <shogi-cell v-for="(koma,index) in capturedKomaList"
      :key="index"
      :index="index"
      :boardName="$options.name"
      :img="resolveKomaImg(koma)"
      :komaName="resolveKomaName(koma)"
      :isEnemy="isEnemyBoard"
      @cellClicked="handleCellClicded">
    </shogi-cell>
  </div>
</template>

<script>
import shogiCell from './shogiCell.vue';
import {mapGetters} from 'vuex'
const shogiUtil = require('common/shogiUtil');
import komaImgResource from './resource';

export default {
  name: 'komaBoard',
  components: {
    shogiCell
  },
  props: {
    playerSide: String,
    isEnemyBoard:Boolean
  },
  computed:{
      ...mapGetters([
        'boardState'
      ]),
      // playerSideは駒盤のサイドを表現するため、相手の駒を保有
      capturedKomaList:function(){
        if(this.playerSide==='1'){
          return this.boardState.capturedPlayer2KomaList;
        }
        if(this.playerSide==='2'){
          return this.boardState.capturedPlayer1KomaList;
        }
        return null;
      }
  },
  methods:{
      resolveKomaImg: function(koma){
        if (koma==="") return "";
        /** 最初の数字（先手後手）を除く */
        const komaAbbre=koma.slice(1);
        return komaImgResource[komaAbbre].resourece;
      },
      resolveKomaName: function(koma){
        return shogiUtil.resolveKomaName(koma);
      },
      handleCellClicded: function(clickedCell){
        this.$emit('cellClicked',clickedCell);
      }
  }
}
</script>

<style scoped> 
  .koma-board-grid {
    margin: 1px 10px;
    justify-content: center;
    background: url("../assets/shogi-img/board/japanese-chess-bg.jpg");
    background-repeat: no-repeat;
    background-size: auto;
    background-position: center;
    display: inline-grid;
    grid-template-columns: repeat(4, 60px);
    grid-template-rows: repeat(4, 64px);
  }
  .koma-board-grid.enemyBoard{
    vertical-align: top;
  }
  .koma-board-grid.selfBoard{
    vertical-align: bottom;
  }
</style>
